import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ children, roles }) {
  const { user, token, bootstrapped } = useAuth();
  if (!bootstrapped) {
    return (
      <div className="min-h-screen bg-canvas grid place-items-center">
        <Loader2 className="h-6 w-6 animate-spin text-cyan-300" />
      </div>
    );
  }
  if (!token || !user) return <Navigate to="/login" replace />;
  // Force any authenticated user with a pending password change to the reset
  // page before they can use the rest of the app.
  if (user.must_change_password) return <Navigate to="/force-password-change" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/app/dashboard" replace />;
  return children;
}
